(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["quick-order-list"] && !Shopify.designMode) return;
  try {
    
  class LookbookOrderEnhanced extends HTMLElement {
    connectedCallback() {
      this.toastTimer = null;

      this.addEventListener('click', (event) => {
        const optionButton = event.target.closest('.lookbook-option-button');

        if (optionButton) {
          this.handleOptionClick(optionButton);
          return;
        }

        const plus = event.target.closest('[data-quantity-plus], [data-row-quantity-plus]');
        const minus = event.target.closest('[data-quantity-minus], [data-row-quantity-minus]');
        const remove = event.target.closest('[data-remove-variant]');
        const addMore = event.target.closest('[data-lookbook-add-more]');
        const addToCart = event.target.closest('[data-lookbook-add-cart]');

        if (plus || minus) {
          this.handleQuantityButton(plus || minus, Boolean(plus));
        }

        if (remove) {
          this.updateVariantQuantity(remove.dataset.removeVariant, 0, remove.closest('[data-lookbook-product]'));
        }

        if (addMore) {
          this.selectNextUnaddedVariant(addMore.closest('[data-lookbook-product]'));
        }

        if (addToCart) {
          this.addSelectionsToCart(addToCart);
        }
      });

      this.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quantity-input], [data-row-quantity-input]');

        if (input) {
          this.handleQuantityInput(input);
        }
      });

      this.querySelectorAll('[data-lookbook-product]').forEach((productCard) => {
        this.hydrateQuantities(productCard);
        this.updateSelectedVariant(productCard, false);
      });

      this.updateAddToCartState();
    }

    handleOptionClick(button) {
      const productCard = button.closest('[data-lookbook-product]');
      const optionPosition = button.dataset.optionPosition;
      const optionValue = button.dataset.optionValue;

      productCard
        .querySelectorAll(`.lookbook-option-button[data-option-position="${optionPosition}"]`)
        .forEach((optionButton) => {
          optionButton.setAttribute('aria-pressed', optionButton === button ? 'true' : 'false');
        });

      const selectedLabel = productCard.querySelector(`[data-selected-option-label="${optionPosition}"]`);

      if (selectedLabel) {
        selectedLabel.textContent = optionValue;
      }

      if (button.dataset.isColor === 'true') {
        this.updateThumbnailForColor(productCard, optionPosition, optionValue);
      }

      this.updateSelectedVariant(productCard, false);
    }

    handleQuantityButton(button, isPlus) {
      const input = button.parentElement.querySelector('input');

      if (!input) {
        return;
      }

      const currentValue = Math.max(0, Number(input.value || 0));
      input.value = isPlus ? currentValue + 1 : Math.max(0, currentValue - 1);

      this.handleQuantityInput(input);
    }

    handleQuantityInput(input) {
      const productCard = input.closest('[data-lookbook-product]');
      const quantity = Math.max(0, Number(input.value || 0));

      input.value = quantity;

      if (input.hasAttribute('data-row-quantity-input')) {
        this.updateVariantQuantity(input.dataset.variantId, quantity, productCard);
        return;
      }

      const variantId = productCard.dataset.selectedVariantId;

      if (variantId) {
        this.updateVariantQuantity(variantId, quantity, productCard);
      }
    }

    hydrateQuantities(productCard) {
      this.getVariants(productCard).forEach((variant) => {
        variant.quantity = 0;
      });
    }

    updateVariantQuantity(variantId, quantity, productCard) {
      const variants = this.getVariants(productCard);
      const variant = variants.find((item) => String(item.id) === String(variantId));

      if (!variant) {
        return;
      }

      variant.quantity = quantity;

      const currentInput = productCard.querySelector('[data-quantity-input]');

      if (String(productCard.dataset.selectedVariantId) === String(variantId) && currentInput) {
        currentInput.value = quantity;
      }

      const row = productCard.querySelector(`[data-lookbook-selected-row="${variantId}"]`);
      const rowInput = row ? row.querySelector('[data-row-quantity-input]') : null;

      if (row) {
        row.hidden = quantity === 0;
      }

      if (rowInput) {
        rowInput.value = quantity;
      }

      this.updateAddToCartState();
    }

    updateAddToCartState() {
      const button = this.querySelector('[data-lookbook-add-cart]');
      const hasSelection = this.getSelectedCartItems().length > 0;
      const section = this.closest('.shopify-section') || this.closest('[id^="shopify-section-"]');

      if (button) {
        button.disabled = !hasSelection;
      }

      if (section) {
        section.classList.toggle('has-lookbook-selection', hasSelection);
      }
    }

    async addSelectionsToCart(button) {
      const items = this.getSelectedCartItems();

      if (items.length === 0) {
        this.showToast('Choose at least one item first.', true);
        this.updateAddToCartState();
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        for (const item of items) {
          await this.addSingleVariantToCart(item);
        }

        const cart = await this.fetchCart();

        this.resetSelections();
        this.updateFooter(cart);
        this.showToast(this.dataset.addedMessage);


        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart } }));
      } catch (error) {
        console.error('Could not add lookbook selections to cart', error);
        this.showToast(error.message || 'Could not add to cart. Please try again.', true);
      } finally {
        button.removeAttribute('aria-busy');
        this.updateAddToCartState();
      }
    }

    showToast(message, isError = false) {
      const toast = this.querySelector('[data-lookbook-toast]');

      if (!toast) {
        return;
      }

      window.clearTimeout(this.toastTimer);

      toast.textContent = message;
      toast.classList.toggle('is-error', isError);
      toast.classList.add('is-visible');

      this.toastTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2600);
    }

    getSelectedCartItems() {
      const items = [];

      this.querySelectorAll('[data-lookbook-product]').forEach((productCard) => {
        this.getVariants(productCard).forEach((variant) => {
          const quantity = Math.max(0, Number(variant.quantity || 0));

          if (quantity > 0 && variant.available) {
            items.push({
              id: String(variant.id),
              quantity,
            });
          }
        });
      });

      return items;
    }

    async addSingleVariantToCart(item) {
      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      const formData = new FormData();

      formData.append('id', item.id);
      formData.append('quantity', String(item.quantity));

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      const payload = await response.json().catch(() => null);

      if (!response.ok) {
        const message =
          payload && (payload.description || payload.message)
            ? payload.description || payload.message
            : 'Could not add to cart. Please try again.';

        throw new Error(message);
      }

      return payload;
    }

    async fetchCart() {
      const root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

      const response = await fetch(`${root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Added to cart, but could not refresh cart summary.');
      }

      return response.json();
    }

    resetSelections() {
      this.querySelectorAll('[data-lookbook-product]').forEach((productCard) => {
        this.getVariants(productCard).forEach((variant) => {
          variant.quantity = 0;
        });

        productCard.querySelectorAll('[data-quantity-input], [data-row-quantity-input]').forEach((input) => {
          input.value = 0;
        });

        productCard.querySelectorAll('[data-lookbook-selected-row]').forEach((row) => {
          row.hidden = true;
        });
      });

      this.updateAddToCartState();
    }

    updateFooter(cart) {
      const count = this.querySelector('[data-lookbook-cart-count]');
      const subtotal = this.querySelector('[data-lookbook-cart-subtotal]');

      if (count) {
        count.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;
      }

      if (subtotal) {
        subtotal.textContent = `Subtotal: ${this.formatMoney(cart.items_subtotal_price)}`;
      }
    }

    formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }

      return (cents / 100).toFixed(2);
    }

    getVariants(productCard) {
      const script = productCard.querySelector('[data-lookbook-variants]');

      if (!script) {
        return [];
      }

      if (script._variants) {
        return script._variants;
      }

      try {
        script._variants = JSON.parse(script.textContent);
        return script._variants;
      } catch (error) {
        return [];
      }
    }

    getSelectedOptions(productCard) {
      const selectedOptions = [];

      productCard.querySelectorAll('.lookbook-option').forEach((optionGroup) => {
        const selectedButton = optionGroup.querySelector('.lookbook-option-button[aria-pressed="true"]');

        selectedOptions[Number(optionGroup.dataset.optionPosition) - 1] = selectedButton
          ? selectedButton.dataset.optionValue
          : null;
      });

      return selectedOptions;
    }

    findExactVariant(variants, selectedOptions) {
      return variants.find((variant) => {
        return selectedOptions.every((selectedOption, index) => {
          return selectedOption === null || variant[`option${index + 1}`] === selectedOption;
        });
      });
    }

    updateSelectedVariant(productCard, preserveQuantity = true) {
      const variants = this.getVariants(productCard);
      const selectedVariant = this.findExactVariant(variants, this.getSelectedOptions(productCard));
      const quantityBox = productCard.querySelector('[data-lookbook-current-quantity]');
      const soldOut = productCard.querySelector('[data-lookbook-soldout]');
      const currentInput = productCard.querySelector('[data-quantity-input]');
      const currentPrice = productCard.querySelector('[data-lookbook-current-price]');

      if (!selectedVariant || !selectedVariant.available) {
        productCard.dataset.selectedVariantId = selectedVariant ? selectedVariant.id : '';

        if (quantityBox) {
          quantityBox.hidden = true;
        }

        if (soldOut) {
          soldOut.hidden = false;
        }

        this.updateOptionAvailability(productCard);
        return;
      }

      productCard.dataset.selectedVariantId = selectedVariant.id;

      if (quantityBox) {
        quantityBox.hidden = false;
      }

      if (soldOut) {
        soldOut.hidden = true;
      }

      if (currentInput) {
        currentInput.value = preserveQuantity
          ? Math.max(0, Number(currentInput.value || 0))
          : Number(selectedVariant.quantity || 0);
      }

      if (currentPrice) {
        currentPrice.textContent = selectedVariant.price;
      }

      if (selectedVariant.image) {
        this.updateThumbnail(productCard, selectedVariant);
      }

      this.updateOptionAvailability(productCard);
    }

    updateOptionAvailability(productCard) {
      const variants = this.getVariants(productCard);
      const selectedOptions = this.getSelectedOptions(productCard);

      productCard.querySelectorAll('.lookbook-option-button').forEach((button) => {
        const positionIndex = Number(button.dataset.optionPosition) - 1;
        const nextOptions = [...selectedOptions];

        nextOptions[positionIndex] = button.dataset.optionValue;

        const matchingVariant = variants.find((variant) => {
          return nextOptions.every((selectedOption, index) => {
            return selectedOption === null || variant[`option${index + 1}`] === selectedOption;
          });
        });

        button.classList.toggle('is-unavailable', !matchingVariant || !matchingVariant.available);
      });
    }

    updateThumbnailForColor(productCard, colorPosition, colorValue) {
      const variants = this.getVariants(productCard);
      const imageVariant = variants.find(
        (variant) => variant[`option${Number(colorPosition)}`] === colorValue && variant.image
      );

      if (imageVariant) {
        this.updateThumbnail(productCard, imageVariant);
      }
    }

    updateThumbnail(productCard, variant) {
      const thumbnail = productCard.querySelector('[data-lookbook-thumbnail]');

      if (!thumbnail || !variant.image) {
        return;
      }

      thumbnail.style.opacity = '0';

      window.setTimeout(() => {
        thumbnail.src = variant.image;

        if (variant.imageSrcset) {
          thumbnail.srcset = variant.imageSrcset;
        }

        thumbnail.style.opacity = '1';
      }, 90);
    }

    selectNextUnaddedVariant(productCard) {
      const variants = this.getVariants(productCard);
      const nextVariant =
        variants.find((variant) => variant.available && Number(variant.quantity || 0) === 0) ||
        variants.find((variant) => variant.available);

      if (!nextVariant) {
        return;
      }

      [nextVariant.option1, nextVariant.option2, nextVariant.option3].forEach((optionValue, index) => {
        if (!optionValue) {
          return;
        }

        const position = index + 1;
        const button = Array.from(
          productCard.querySelectorAll(`.lookbook-option-button[data-option-position="${position}"]`)
        ).find((optionButton) => {
          return optionButton.dataset.optionValue === optionValue;
        });

        if (button) {
          button.click();
        }
      });

      const input = productCard.querySelector('[data-quantity-input]');

      if (input) {
        input.value = Number(nextVariant.quantity || 0);
        input.focus();
      }
    }
  }

  if (!customElements.get('lookbook-order-enhanced')) {
    customElements.define('lookbook-order-enhanced', LookbookOrderEnhanced);
  }

  } catch(e) { console.error(e); }
})();
})();
